const regExpr = /[^a-zA-Z0-9- ]/g;

const getLineItems = (data, r) => {
  let items = ``;

  for (let i = 0; i < data.length; i++) {
    const l = data[i];
    items += `<Item>
          <SKU>${l?.product.replace(regExpr, "")}</SKU>
          <Descrip>[${l?.printType}] ${r?.subPOs?.join()}</Descrip>
          <Color>${l?.color}</Color>
          <Qty>${l?.qty}</Qty>
          <Size>${l?.size}</Size>
          <Type>${l?.printType}</Type>
          <Style>${l?.product?.split("-")[0]?.replace(regExpr, "")}</Style>
          <ProcessMode>Piece</ProcessMode>
              ${l?.printAreas?.map(
                (p) => `
                  <Design>
                      <Location>${p?.printAreaName}</Location>
                      <Thumb>${p?.artworkUrl}</Thumb>
                      <SourceFile>${p?.artworkUrl.replace(
                        ".jpg",
                        ".png"
                      )}</SourceFile>
                      <WhiteUnderbaseRequired>false</WhiteUnderbaseRequired>
                  </Design>`
              )}
      </Item>`;
  }
  return items;
};

export const getStaplesOrderXml = (
  data
) => `<AddXml xmlns="http://tempuri.org/">
    <OrderString>
        <Request>
            <CustID>1</CustID>
            <PO>STAPLES-${data?.ID}</PO>
            <Source>Admin</Source>
            <Store>BOT</Store>
            <StoreID>2</StoreID>
            <ShipTo>
                <FirstName>${data?.shippingAddress?.name?.replace(
                  regExpr,
                  ""
                )}</FirstName>
                <LastName></LastName>
                <Company></Company>
                <Adrx1>${data?.shippingAddress?.addressLine1?.replace(
                  regExpr,
                  ""
                )}</Adrx1>
                <Adrx2>${data?.shippingAddress?.addressLine2?.replace(
                  regExpr,
                  ""
                )}</Adrx2>
                <City>${data?.shippingAddress?.city?.replace(
                  regExpr,
                  ""
                )}</City>
                <State>${data?.shippingAddress?.state?.replace(
                  regExpr,
                  ""
                )}</State>
                <Zip>${data?.shippingAddress?.zipCode?.replace(
                  regExpr,
                  ""
                )}</Zip>
                <Country>${data?.shippingAddress?.country?.replace(
                  regExpr,
                  ""
                )}</Country>
            </ShipTo>
            <ShipFrom>
                <FirstName>Big Oven Tees</FirstName>
                <LastName></LastName>
                <Company>Big Oven Tees</Company>
                <Adrx1>122 Middleton St.</Adrx1>
                <Adrx2></Adrx2>
                <City>Brantford</City>
                <State>ON</State>
                <Zip>N3S7V7</Zip>
                <Country>CA</Country>
                <Email>info@bigoventees.com</Email>
            </ShipFrom>                
            <ShipMethod>${
              data?.shippingAddress?.country === "CA"
                ? "[Canada Post] Expedited Parcel"
                : data?.shippingAddress?.country === "US"
                ? "[Canada Post] Tracked Packet - USA"
                : "[Canada Post] Tracked Packet - International"
            }</ShipMethod>
            <ProductionPriority>Normal</ProductionPriority>
            <Notes>Staples Promotional Products</Notes>
            ${getLineItems(data?.lineItems, data)}
        </Request>
    </OrderString>
  </AddXml>`;
